import type { ICategory, IFindGamesOptions } from "../types"
import { computed } from "vue"
import { useBetStore } from "../../../../store"

export function useIsMobile() {
  const store = useBetStore()

  return computed(() => store.getScreenWidth < 512)
}

export function findGamesInCategory(categories: ICategory[], options: IFindGamesOptions = {}) {
  const { search = "", categoryId = null } = options

  const category = categories.find(cat => cat.id === categoryId)

  if (!category || !category.games) {
    return []
  }

  if (!search) {
    return category.games
  }

  return category.games.filter(game =>
    game.name.toLowerCase().includes(search.toLowerCase()),
  )
}

export function getCurrencyConfig(currency) {
  const currencyMap = {
    ETH: { code: "ETH", protocol: "ERC-20" },
    USDC: { code: "USDC", protocol: "ERC-20" },
    USDTT: { code: "USDT", protocol: "TRC20" },
    USDTE: { code: "USDT", protocol: "ERC20" },
    SOL: { code: "SOL", protocol: "SOL" },
    BNB: { code: "BNB", protocol: "BEP-20" },
  }

  return currencyMap[currency] || { code: currency, protocol: "UNKNOWN" }
}
